<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ showTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col v-if="!showVeiksmas" cols="12" v-html="text"></v-col>
              <v-col v-if="showVeiksmas" cols="12" md="12">
                <el-radio-group
                  class="my-0"
                  required
                  :items="perdavimasVeiksmas"
                  v-model="perdavimas"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button primary @click.native.stop="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import userRole from '../../mixins/userRole'

export default {
  name: 'ModalPaslaugaConfirm',
  props: {
    title: String,
    text: String,
    action: String,
    item: Object,
    value: Boolean,
  },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      perdavimas: null,
    }
  },
  computed: {
    isTeikimas() {
      return this.item && this.item.objektasTipas.includes('teikiamas')
    },
    tooltipPrefix() {
      return this.isTeikimas ? 'Įkeitimas. Teikimas.' : 'Įkeitimas. Sandoris.'
    },
    perdavimasVeiksmas() {
      return [
        {
          label: 'Įkeitimo objektas perduodamas kreditoriui',
          tooltip: `Savitarna. Nauja paslauga. ${this.tooltipPrefix} Įkeitimo objektas perduodamas kreditoriui`,
          value: 1,
        },
        {
          label: 'Įkeitimo objektas perduodamas trečiajam asmeniui',
          tooltip: `Savitarna. Nauja paslauga. ${this.tooltipPrefix} Įkeitimo objektas trečiajam asmeniui`,
          value: 2,
        },
        {
          label: 'Įkeitimo objektas lieka įkaito davėjui',
          tooltip: `Savitarna. Nauja paslauga. ${this.tooltipPrefix} Įkeitimo objektas lieka įkaito davėjui`,
          value: 0,
        },
      ]
    },
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        if (!value) {
          this.perdavimas = null
          this.$validator.reset()
        }
        this.$emit('input', value)
      },
    },
    modalAction() {
      return this.action ? this.action : 'Confirm'
    },
    isJuridinis() {
      return this.role('EL_JA')
    },
    showVeiksmas() {
      return this.isJuridinis && !this.isTeikimas
    },
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.item.perduodamasKreditoriui = this.showVeiksmas
            ? this.perdavimas
            : 1
          this.$emit('confirm' + this.modalAction, this.item)
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.$emit('cancelConfirm', this.item)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.cancelData()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
